import { BuilderProps, FieldTypeKind } from '@components/form/v2';

import { AttributeFieldType, AttributeType } from 'api/attributes/requests';
import { isSelectFieldType } from 'utils/attribute-field-types';

// Define which field types are compatible for each attribute type
export const attributeTypeToAllowedFieldTypes: Record<AttributeFieldType, FieldTypeKind[]> = {
  single_select: ['input-dropdown', 'input-single-choice'],
  multi_select: [],
  text: [],
  paragraph: [],
  phone_number: [],
  email: [],
  date: [],
  file: [],
  file_multi: [],
  boolean: [],
  user: [],
  decimal: [],
  number: [],
};

export const getSidebarAttributeBuilderProps = ({
  attribute,
  kind,
  isJourneyField,
  hasHiddenOptionsList,
}: {
  attribute: Pick<AttributeType, 'attributeType' | 'options'>;
  kind: FieldTypeKind;
  isJourneyField: boolean;
  hasHiddenOptionsList: boolean;
}) => {
  const builderProps: BuilderProps = {
    canEditOptions: isJourneyField
      ? isSelectFieldType(attribute.attributeType)
      : Boolean(attribute.options) && hasHiddenOptionsList,
    canEditKind: attributeTypeToAllowedFieldTypes[attribute.attributeType],
  };

  if (kind === 'input-file') {
    builderProps.canEditFilesMultiple = false;
  }

  return builderProps;
};
